import { Buffer } from 'buffer';
import { isValidElement, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const dateInput = (date = new Date(), time = false) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    if (time) {
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    else {
        return `${year}-${month}-${day}`;
    }
};

const dollarNumber = (number) => parseFloat(number.replace(/[$,]/g, ''));

const excelLink = (buffer) => {
    if (!buffer.data)
        throw Error('Buffer should contains "data" property');
    const bufferData = Buffer.from(buffer.data);
    const blob = new Blob([bufferData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    return URL.createObjectURL(blob);
};

const extractString = (obj) => {
    if (typeof obj === 'string')
        return obj;
    else if (isValidElement(obj)) {
        return extractString((obj?.props).children || '');
    }
    else if (Array.isArray(obj)) {
        return obj.map((e) => extractString(e)).join(' ');
    }
    else {
        return obj?.toString() || '';
    }
};

function findNestedProperty({ object, key, }) {
    if (!key) {
        return undefined;
    }
    const keys = key.split('.');
    for (const currentKey of keys) {
        if (object && Object.prototype.hasOwnProperty.call(object, currentKey)) {
            object = object[currentKey];
        }
        else {
            return undefined;
        }
    }
    return object;
}

const formatFiles = (value, sizeArray) => {
    const file = typeof value === 'string' ? +value : value;
    const i = Math.floor(Math.log(file) / Math.log(1024));
    return `${parseFloat((file / Math.pow(1024, i)).toFixed(2))} ${sizeArray ? sizeArray[i] : ['Б.', 'КБ.', 'МБ.', 'ГБ.', 'ТБ.'][i]}`;
};

const formatNumbers = (value, lookup = [
    { value: 1e12, symbol: ' трлн.' },
    { value: 1e9, symbol: ' млрд.' },
    { value: 1e6, symbol: ' млн.' },
    { value: 1e3, symbol: ' тыс.' },
    { value: 1, symbol: '' },
]) => {
    const num = typeof value === 'string' ? +value : value;
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().find(function (item) {
        return num >= item.value;
    });
    const answer = item ? (num / item.value).toFixed(1).replace(rx, '$1') + item.symbol : '0';
    return typeof value === 'string' ? answer.toString() : answer;
};

const futureDate = (days) => {
    return new Date(new Date().getTime() + +days * 24 * 60 * 60 * 1000).getTime();
};

const getAndSetLs = (getItem, setItem, objItem, callback) => {
    const ls = JSON.parse(localStorage.getItem(getItem) || '{}');
    objItem
        ? localStorage.setItem(getItem, JSON.stringify({ ...ls, [objItem]: setItem }))
        : localStorage.setItem(getItem, JSON.stringify(setItem));
    callback && callback();
};

function getCurrentMonth(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-01`;
}

const getFileExtension = (filename) => {
    const extensionMatch = /\.([^.]+)$/.exec(filename);
    if (extensionMatch) {
        return extensionMatch[1];
    }
    else {
        return '';
    }
};

const c=e=>"number"==typeof e&&!isNaN(e),d=e=>"string"==typeof e,u=e=>"function"==typeof e,m=e=>isValidElement(e)||d(e)||u(e)||c(e);const v=new Map;let h=[];const T=new Set,b=()=>v.size>0;function I(e,t){var n;if(t)return !(null==(n=v.get(t))||!n.isToastActive(e));let o=!1;return v.forEach(t=>{t.isToastActive(e)&&(o=!0);}),o}function _(e,t){m(e)&&(b()||h.push({content:e,options:t}),v.forEach(n=>{n.buildToast(e,t);}));}function C(e,t){v.forEach(n=>{null!=t&&null!=t&&t.containerId?(null==t?void 0:t.containerId)===n.id&&n.toggle(e,null==t?void 0:t.id):n.toggle(e,null==t?void 0:t.id);});}let w=1;const k=()=>""+w++;function P(e){return e&&(d(e.toastId)||c(e.toastId))?e.toastId:k()}function M(e,t){return _(e,t),t.toastId}function x(e,t){return {...t,type:t&&t.type||e,toastId:P(t)}}function A(e){return (t,n)=>M(t,x(e,n))}function B(e,t){return M(e,x("default",t))}B.loading=(e,t)=>M(e,x("default",{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...t})),B.promise=function(e,t,n){let o,{pending:s,error:a,success:r}=t;s&&(o=d(s)?B.loading(s,n):B.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null},l=(e,t,s)=>{if(null==t)return void B.dismiss(o);const a={type:e,...i,...n,data:s},r=d(t)?{render:t}:t;return o?B.update(o,{...a,...r}):B(r.render,{...a,...r}),s},c=u(e)?e():e;return c.then(e=>l("success",r,e)).catch(e=>l("error",a,e)),c},B.success=A("success"),B.info=A("info"),B.error=A("error"),B.warning=A("warning"),B.warn=B.warning,B.dark=(e,t)=>M(e,x("default",{theme:"dark",...t})),B.dismiss=function(e){!function(e){var t;if(b()){if(null==e||d(t=e)||c(t))v.forEach(t=>{t.removeToast(e);});else if(e&&("containerId"in e||"id"in e)){var n;(null==(n=v.get(e.containerId))?void 0:n.removeToast(e.id))||v.forEach(t=>{t.removeToast(e.id);});}}else h=h.filter(t=>null!=e&&t.options.toastId!==e);}(e);},B.clearWaitingQueue=function(e){void 0===e&&(e={}),v.forEach(t=>{!t.props.limit||e.containerId&&t.id!==e.containerId||t.clearQueue();});},B.isActive=I,B.update=function(e,t){void 0===t&&(t={});const n=((e,t)=>{var n;let{containerId:o}=t;return null==(n=v.get(o||1))?void 0:n.toasts.get(e)})(e,t);if(n){const{props:o,content:s}=n,a={delay:100,...o,...t,toastId:t.toastId||e,updateId:k()};a.toastId!==e&&(a.staleId=e);const r=a.render||s;delete a.render,M(r,a);}},B.done=e=>{B.update(e,{progress:1});},B.onChange=function(e){return T.add(e),()=>{T.delete(e);}},B.play=e=>C(!0,e),B.pause=e=>C(!1,e);

const notify = (message, type = 'success', duration = 1000, sound = false) => {
    const validTypes = ['success', 'error', 'warning', 'info'];
    if (!validTypes.includes(type))
        return console.error(`Invalid toast type: ${type}`);
    return B[type](message, {
        position: 'bottom-right',
        autoClose: duration,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
    });
};

const numberDivide = (number) => {
    let num = typeof number === 'string' ? number : number.toString();
    if (!num.match(/^-?\d+(?:[.,]\d*?)?$/))
        throw new SyntaxError(num + ' is Not a number');
    num = num.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
    return num.toString().indexOf('.') > -1 ? num.substr(0, num.toString().indexOf('.') + 3) : num;
};

const phoneMask = (value) => {
    if (!value)
        return;
    let val = value.toString();
    if (val.length >= 1) {
        val = '+' + val.replace(/[^\d]/g, '');
    }
    if (val.length > 2) {
        val = val.substr(0, 2) + '(' + val.substr(2, val.length);
    }
    if (val.length > 6) {
        val = val.substr(0, 6) + ')' + val.substr(6, val.length);
    }
    if (val.length > 10) {
        val = val.substr(0, 10) + '-' + val.substr(10, val.length);
    }
    if (val.length > 13) {
        val = val.substr(0, 13) + '-' + val.substr(13, val.length);
    }
    val = val.substr(0, 16);
    return val;
};

const ReactPortal = ({ children, wrapperId }) => createPortal(children, document.getElementById(wrapperId));

const sortByProperty = ({ data, property, uncategorized }) => {
    if (!data || !data.length) {
        return [];
    }
    const sortedByProperty = {};
    data.forEach((item) => {
        const propertyPath = property.split('.');
        let value = item;
        for (const prop of propertyPath) {
            if (value && Object.prototype.hasOwnProperty.call(value, prop) && value[prop]) {
                value = value[prop];
            }
            else {
                value = uncategorized ?? 'undefined'; // if there's no value in property
                break;
            }
        }
        if (!sortedByProperty[value]) {
            sortedByProperty[value] = [];
        }
        sortedByProperty[value].push(item);
    });
    return sortedByProperty;
};

const textEllipsis = (text, max) => {
    return text.substr(0, max - 1) + '...' + text.substr(-1 - 6, 7);
};

const unixToDate = (value, type, inSeconds = false, monthsArr = [
    'янв.',
    'фев.',
    'мар ',
    'апр.',
    'май ',
    'июнь',
    'июль',
    'авг.',
    'сент.',
    'окт.',
    'нояб.',
    'дек.',
]) => {
    const date = typeof value === 'string'
        ? new Date(+value * (inSeconds ? 1000 : 1))
        : new Date(value * (inSeconds ? 1000 : 1));
    const minutes = '0' + date.getMinutes();
    const hours = '0' + date.getHours();
    const seconds = '0' + date.getSeconds();
    const month = '0' + date.getMonth();
    const dayDate = '0' + date.getDate();
    let day = date.getDay();
    let minutesZero = date.getMinutes();
    let secondsZero = date.getSeconds();
    let hoursZero = date.getHours();
    switch (type) {
        case 'DHMS':
            day = day > 0 ? day + ' дн.' : '';
            hoursZero = hoursZero > 0 ? hoursZero + ' ч.' : '';
            minutesZero = minutesZero > 0 ? minutesZero + ' мин.' : '';
            secondsZero = secondsZero > 0 ? secondsZero + ' сек.' : '';
            return `${day} ${hoursZero} ${minutesZero} ${secondsZero}`;
        case 'DM':
            return `${date.getDate()} ${monthsArr[date.getMonth()]}`;
        case 'HM':
            return `${hours.substr(-2)}:${minutes.substr(-2)}`;
        case 'HMS':
            return `${hours.substr(-2)}:${minutes.substr(-2)}:${seconds.substr(-2)}`;
        case 'DMY':
            return `${date.getDate()} ${monthsArr[date.getMonth()]} ${date.getFullYear()}`;
        case 'DMYNUM':
            return `${dayDate.substr(-2)}.${month.substr(-2)}.${date.getFullYear()}`;
        case 'DMYHM':
            return `${date.getDate()} ${monthsArr[date.getMonth()]} ${date.getFullYear()} ${hours.substr(-2)}:${minutes.substr(-2)}`;
        default:
            return 'Missing type param in func';
    }
};

const useStateToggle = () => {
    const [state, setState] = useState(false);
    const handleStateToggle = () => setState((prev) => !prev);
    return [state, handleStateToggle, setState];
};

const useTitle = (domen, name) => {
    useEffect(() => {
        document.title = `${domen} - ${name}`;
    }, [name]);
};

export { ReactPortal, dateInput, dollarNumber, excelLink, extractString, findNestedProperty, formatFiles, formatNumbers, futureDate, getAndSetLs, getCurrentMonth, getFileExtension, notify, numberDivide, phoneMask, sortByProperty, textEllipsis, unixToDate, useStateToggle, useTitle };
//# sourceMappingURL=index.js.map
